<template>
  <div class="renwu">
    <!-- 结算记录 -->
    <div class="top">
      <Date-picker
        @on-change="datePicker"
        :options="options2"
        class="data"
        type="daterange"
        placeholder="选择日期"
      ></Date-picker>
      <Button class="btn fourSize" type="success" @click="daochu" ghost
        >导出</Button
      >
    </div>
    <div class="table-cont">
      <Table
        @on-sort-change="changesort"
        stripe
        @on-selection-change="selectChange"
        :columns="columns"
        :data="data"
      ></Table>
    </div>
    <div class="page-div">
      <div class="page-div-left">
        已选 <span>{{ selectNum }}</span> 条
      </div>
      <Page
        @on-page-size-change="changepeoplepage"
        @on-change="changePeoplecurrent"
        :total="obj.total"
        show-elevator
        show-total
        :current="current"
        :page-size="pageSize"
        show-sizer
        class="page-div-page"
      />
    </div>

    <Alert class="alertTitle" v-show="alertTitleIshow" show-icon type="success"
      >操作成功</Alert
    >
    <Alert
      class="alertTitle"
      v-show="alertTitleIshow2"
      type="error"
      show-icon
      >{{ alertTitle }}</Alert
    >

    <!-- <Spin fix v-show="isiconfontshow">
      <span class="iconfont demo-spin-icon-load ivu-icon">&#xe71d;</span>
      <div>距离有些遥远，小简 正在努力中……</div>
    </Spin> -->
  </div>
</template>
<script>
    import {
        formatMoney,
        selectStatementRecordList
    } from "../servers/api";
    export default {
        name: "jiesuan",
        data() {
            return {
                isiconfontshow: false,
                alertTitleIshow: false,
                alertTitleIshow2: false,
                alertTitle: "",
                selectNum: 0,
                selectList: [],
                options2: {
                    shortcuts: [{
                        text: "最近一周",
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            return [start, end];
                        }
                    }, {
                        text: "最近一个月",
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            return [start, end];
                        }
                    }, {
                        text: "最近三个月",
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            return [start, end];
                        }
                    }]
                },
                data: [],
                name: "可预约",
                background: "#fff",
                columns: [{
                    type: "selection",
                    width: 50,
                    align: "center"
                }, {
                    title: "结算编号",
                    // width: 150,
                    align: "center",
                    key: "statementId",
                    ellipsis: true,
                    sortable: true
                }, {
                    title: "结算日期",
                    align: "center",
                    ellipsis: true,
                    sortable: true,
                    key: "receivedDate",
                    render: (h, params) => {
                        let a = params.row.receivedDate;
                        let num = "";
                        if (a) {
                            num = a.slice(0, 10);
                        }

                        return h(
                            "div", {
                                style: {
                                    height: "30px",
                                    "line-height": "30px",
                                    "text-align": "center",
                                    "font-size": "13px",
                                    color: "#7F7F7F"
                                }
                            },
                            num
                        );
                    }
                }, {
                    title: "结算金额",
                    align: "center",
                    ellipsis: true,
                    sortable: true,
                    key: "receivedPrice",
                    render: (h, params) => {
                        let a = "￥" + formatMoney(params.row.receivedPrice);
                        return h("div", [
                            h(
                                "span", {
                                    style: {
                                        display: "inline-block",
                                        width: "100%",
                                        height: "25px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        "line-height": "30px",
                                        color: "#7F7F7F"
                                    }
                                },
                                a
                            )
                        ]);
                    }
                }, {
                    title: "汇款单号",
                    align: "center",
                    ellipsis: true,
                    sortable: true,
                    key: "sendersRer"
                }, {
                    title: "操作",
                    key: "awssd",
                    align: "center",
                    width: 110,
                    fixed: "right",
                    render: (h, params) => {
                        // console.log(params)
                        return h(
                            "div", {
                                style: {
                                    // width:'50px',
                                    height: "30px",
                                    "line-height": "30px",
                                    "text-align": "center",
                                    "font-size": "13px",
                                    background: this.background,
                                    border: "1px solid #53CAC3",
                                    "border-radius": "5px",
                                    width: "65px",
                                    "margin-left": "10px",
                                    cursor: "pointer"
                                },
                                on: {
                                    click: () => {
                                        this.goDaoBiao(params.row);
                                    }
                                }
                            },
                            "导出报表"
                        );
                    }
                }],
                current: 1,
                pageSize: 20,
                obj: {},
                orderField: "",
                isAsc: "",
                receivedStartDate: "",
                receivedEndDate: "",
                orderField: "",
                isAsc: ""
            };
        },
        created() {
            this.selectStatementRecordList();
        },
        methods: {
            goDaoBiao(params) {
                //导出报表
                let baseUrl = sessionStorage.getItem("baseUrl");
                let token = JSON.parse(sessionStorage.getItem("login")).token || "";
                window.location.href =
                    baseUrl +
                    "/pms/financial/exportOrderStatementDetail?id=" +
                    params.id +
                    "&token=" +
                    token;
            },
            daochu() {
                let token = "";
                if (sessionStorage.getItem("login")) {
                    token = JSON.parse(sessionStorage.getItem("login")).token || "";
                }
                let list = [];
                if (this.selectNum > 0) {
                    for (let i = 0; i < this.selectList.length; i++) {
                        list.push(this.selectList[i].id);
                    }
                }
                let baseUrl = "";
                if (process.env.NODE_ENV === "development") {
                    //本地
                    baseUrl = "http://192.168.1.114:9082";
                } else {
                    if (process.env.NODE_ENV === "production") {
                        let _host = window.location.host;
                        if (_host == "192.168.1.76") {
                            //测试
                            baseUrl = "http://127.0.0.1:9082";
                        } else {
                            //生产
                            baseUrl = "http://127.0.0.1:9081";
                        }
                    }
                }
                window.location.href =
                    baseUrl +
                    "/pms/financial/exportStatementRecordList?idList" +
                    list.join(",") +
                    "&token=" +
                    token;
            },
            selectChange(item) {
                //表格select选中
                this.selectList = item;
                this.selectNum = this.selectList.length;
            },
            changepeoplepage(num) {
                //换每页请求多少条
                this.pageSize = num;
                this.selectStatementRecordList(1);
            },
            changePeoplecurrent(num) {
                //换页
                this.current = num;
                this.selectStatementRecordList();
            },
            datePicker(data) {
                //时间搜索
                this.receivedStartDate = data[0];
                this.receivedEndDate = data[1];
                this.selectStatementRecordList(1);
            },
            selectStatementRecordList(index) {
                this.isiconfontshow = true;
                if (index) {
                    this.current = 1;
                }
                let params = {
                    pageNum: this.current,
                    pageSize: this.pageSize,
                    receivedStartDate: this.receivedStartDate,
                    receivedEndDate: this.receivedEndDate,
                    orderField: this.orderField,
                    isAsc: this.isAsc
                };
                selectStatementRecordList(params).then(res => {
                    if (res.data.code == 1) {
                        this.selectChange([]);
                        this.isiconfontshow = false;
                        this.obj = res.data.data || {};
                        this.data = res.data.data.list || [];
                    }
                });
            },
            changesort(item) {
                //排序
                this.orderField = item.key;
                this.isAsc = item.order;
                this.current = 1;
                if (item.order == "normal") {
                    this.isAsc = "";
                    this.orderField = "";
                }
                this.selectStatementRecordList(1);
            }
        }
    };
</script>
<style lang="scss" scoped="" type="text/css">
    @import "../css/conmmon.scss";
    @import "../font/iconfont.css";
    .renwu {
        font-size: 13px;
        padding: 15px;
        width: 100%;
        height: 100%;
        overflow: hidden;
        overflow-y: scroll;
        overflow-y: visible;
        .btn {
            float: right;
        }
        .top {
            width: calc(100% - 250px);
            height: 60px;
            line-height: 35px;
            position: fixed;
            top: 111px;
            z-index: 99;
            background: #fff;
            padding-top: 17px;
            left: 220px;
            padding-left: 15px;
            padding-bottom: 15px;
        }
        .select {
            width: 250px;
            margin-right: 15px;
        }
        .journal-input {
            width: 250px;
            vertical-align: top;
        }
        .data {
            width: 250px;
            vertical-align: top;
        }
        .table-cont {
            padding-top: 15px;
            margin: 40px 0 60px;
        }
        .page-div {
            width: 100%;
            margin-top: 15px;
            position: fixed;
            background: #fff;
            width: calc(100% - 270px);
            height: 60px;
            z-index: 99;
            bottom: 0;
            padding-top: 15px;
            .page-div-left {
                float: left;
            }
            .page-div-page {
                float: right;
                margin-right: 15px;
            }
        }
        .title-btn {
            vertical-align: top;
            float: right;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/caiwu/jisuan.vue